import SummaryTableControls from './SummaryTableControls';

export default SummaryTableControls;
